// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"81d72f7e","272":"50ba5dbb"}[chunkId] + ".chunk.css";
};